const AutonomyAiScreen = () => {

    return(
        <p>Autonomy and AI</p>
    )
}

export default AutonomyAiScreen